import { Grid } from "@mui/material";
import Iconborder from "../IconBorder";
import { MarkEmailUnread } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { KeyDriveh4Header } from "../../../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { KeyDriveBodyMin } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDrivePrimaryButton } from "../../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMax } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { Navigate, useNavigate } from "react-router-dom";

export default function EmailSended(): JSX.Element {

    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <>
            <Grid item xs={12} display="flex" justifyContent="center" marginBottom="12px">
                <Iconborder>
                    <MarkEmailUnread sx={{ color: "#22638D", width: "36px", height: "36px" }} />
                </Iconborder>
            </Grid>
            <Grid item xs={12} textAlign="center" marginBottom="32px">
                <KeyDriveh4Header
                    color={"#22638D"}
                    needBold
                    needEllipses={false}
                    text="Verifique seu e-mail cadastrado"
                    sxStyles={{
                        marginBottom: "12px"
                    }}
                />
                <KeyDriveBodyMin
                    color="#7AA1BB"
                    needBold={false}
                    needEllipses={false}
                    text="Acesse o seu e-mail cadastrado e faça a verificação de cadastro."
                />
            </Grid>
            <Grid item xs={12}>
                <KeyDrivePrimaryButton 
                    TextComponent={KeyDriveBodyMax}
                    TextComponentProps={{
                        color: "white",
                        needBold: true,
                        needEllipses: false,
                        text: "Retornar para login"
                    }}
                    needFullWidth
                    onClick={() => {
                        navigate("/login");
                    }}
                />
            </Grid>
        </>
    )
}